export const RESIGN_OPTIONS = [
	{
		label: 'negative reviews',
		value: 'negative_reviews',
	},
	{
		label: 'I didn’t order anything',
		value: 'no_order',
	},
	{
		label: 'no reason',
		value: 'no_reason',
	},
	{
		label: 'other',
		value: 'Other',
	},
	{
		label: 'insufficient funds',
		value: 'insufficient_funds',
	},
];
